/**
 * Converts a string separated by spaces into title case
 * @example
 * toTitle("Hello world, how odd!") === "Hello World, How Odd!"
 */
export function toTitle(str: string): string {
  return str.replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
}

/**
 * Converts a string separated by hiphens into title case
 * @example
 * toTitle("reportsfeed-is-the-best-app") === "Reportsfeed Is The Best App"
 */
export function kebabCaseToTitleCase(kebabCased: string): string {
  return toTitle(kebabCased.replace(/\-/g, ' '));
}

/**
 * Converts a string separated by hiphens into title case
 * @example
 * toTitle("reportsfeed_is_the_best_app") === "Reportsfeed Is The Best App"
 */
export function snakeCaseToTitleCase(snakeCased: string): string {
  return toTitle(snakeCased.replace(/\_/g, ' '));
}
